import React, { useState, useEffect, useRef, useContext } from 'react'
import { Channel, Presence, Socket } from 'phoenix'
import Loading from '../components/Loading'
import { v4 as uuidv4 } from 'uuid'
import { VideoContext } from '~/service/videoConn'

type Status = 'loading' | 'success' | 'fail'

type State = {
  status: Status
  socket?: Socket
  channel?: any
}

export const JanusWebsocketContext = React.createContext<State>({
  status: 'loading',
  channel: null,
})

type Props = {
  token: string
  type: string
  children: React.ReactNode
}

const JanusWebsocketConn: React.FC<Props> = ({ children, token, type }) => {
  const { clearRoom } = useContext(VideoContext)

  const host = process.env.PHOENIX_CUSTOM_WEBSOCKET_PATH
    ? process.env.PHOENIX_CUSTOM_WEBSOCKET_PATH + 'phoenix/socket_janus'
    : 'wss://' + process.env.AGENT_DOMAIN + '/phoenix/socket_janus'

  const socket = new Socket(host, {
    params: { token: token, type: type, uuid: uuidv4() },
    heartbeatIntervalMs: 5000,
  })

  const [alert, setAlert] = useState('')
  const [status, setStatus] = useState<Status>('loading')
  const userChannelRef = useRef<Channel>()

  useEffect((): any => {
    socket.connect()

    socket.onError(e => {
      console.error('Websocket Socket connection error', e)
      setAlert(intl.formatMessage({ id: 'janus.alert.socketError' }))
      setStatus('fail')
      clearRoom()
    })

    socket.onOpen(() => {})

    const userChannel = socket.channel('janus_user:' + token)

    userChannelRef.current = userChannel

    userChannel
      .join()
      .receive('ok', () => {
        setStatus('success')
      })
      .receive('error', res => {
        setAlert(intl.formatMessage({ id: 'janus.alert.leave' }))
        setStatus('fail')
      })

    return () => userChannel.leave()
  }, [])

  return (
    <JanusWebsocketContext.Provider
      value={{
        status,
        channel: userChannelRef.current,
      }}
    >
      <>
        {alert ? (
          <div className="janus__alert">
            {alert}
            <i className="far fa-exclamation-circle"></i>
          </div>
        ) : status == 'loading' ? (
          <div className="janus__alert">
            <Loading />
          </div>
        ) : (
          children
        )}
      </>
    </JanusWebsocketContext.Provider>
  )
}

export default JanusWebsocketConn
